import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { Colors, ColorsType, Radius, Spacing } from '@common/tokens';

export type BoxProps = PropsWithChildren<{
  /** Background color token. Defaults to gray (steelLighter). */
  color?: ColorsType;
  className?: string;
  dataTestId?: string;
}>;

/**
 * A simple container with a filled background color, rounded corners and
 * built-in padding. No borders or shadows — just a colored surface.
 */
export const Box = ({
  color = 'steelLighter',
  className,
  children,
  dataTestId,
}: BoxProps) => (
  <>
    <div className={clsx('wk-box', className)} data-testid={dataTestId}>
      {children}
    </div>
    <style jsx>{`
      .wk-box {
        display: inline-block;
        padding: ${Spacing.sm}px ${Spacing.md}px;
        border-radius: ${Radius.sm};
        background-color: ${Colors[color]};
      }
    `}</style>
  </>
);
